// extracted by mini-css-extract-plugin
export default {"list-item":"m_bf","list-item--navitem":"m_bg"};